/* eslint-disable */
import React, { useEffect } from 'react'

import { Spinner } from '../../../components/UI/Spinner'
import { Header } from '../../../components/Header'
import BlogContainer from '../../../components/BlogContainer'
import Author from '../../../components/BlogContainer/Author'
import { Posts } from '../../../models/blog'
import { GetStaticProps, NextPage, GetStaticPaths } from 'next'
import toast from 'react-hot-toast'

interface Author {
  id: number
  name: string
}

export const getStaticPaths: GetStaticPaths = async () => {
  const res = await fetch(
    `${process.env.NEXT_PUBLIC_BLOG_URL}/wp-json/wpr/v1/authors`
  ).then()
  const data = await res.json()

  const paths = data.map((author: Author) => {
    return {
      params: {
        slug: `${author.name.toLowerCase().split(' ').join('-')}-${author.id}`
      }
    }
  })
  return {
    paths,
    fallback: false
    // paths:[{slug:}]
  }
}

type Params = {
  params: {
    slug: string
  }
}

export const getStaticProps: GetStaticProps = async ({ params }: Params) => {
  const res = await fetch(
    `${
      process.env.NEXT_PUBLIC_BLOG_URL
    }/wp-json/wpr/v1/authors/${params.slug.split('-').pop()}`
  ).then()

  const postsData = await res.json()

  if (postsData.length > 0) {
    return {
      props: {
        postsData: postsData,
        error: false
      }
    }
  } else {
    return {
      props: {
        postsData: null,
        error: true
      }
    }
  }
}

type Props = {
  postsData: Posts[]
  error: boolean
}

export const PostsByAuthor: NextPage<Props, any> = (props: Props) => {
  const { postsData, error } = props

  useEffect(() => {
    if (error) {
      toast.error('There was an error')
    }
  }, [error])

  if (!error) {
    return (
      <>
        <Header />
        <div className="pt-8 px-0 container mx-auto">
          <BlogContainer categorySlug={'/'} posts={postsData} />
          <Author author={postsData[0].author} />
        </div>
      </>
    )
  }

  return (
    <div
      className="pt-8 flex justify-center items-center container mx-auto"
      style={{ minHeight: '100vh' }}
    >
      <Spinner />
    </div>
  )
}

export default PostsByAuthor
